const selectors = {
  header: "[data-header]",
  headerTrigger: "[data-header-trigger]",
  headerAccordion: "[data-header-accordion]",
};

const initHeader = (header) => {
  const trigger = header.querySelector(selectors.headerTrigger);
  const accordions = header.querySelectorAll(selectors.headerAccordion);

  trigger?.addEventListener("click", () => header.classList.toggle("active"));

  accordions?.forEach((accordion) =>
    accordion.addEventListener("click", () => {
      accordion.classList.toggle("active");
    })
  );
};

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    const headers = document.querySelectorAll(selectors.header);

    headers?.forEach(initHeader);
  },
  {
    once: true,
  }
);
